import { Frame, useWidgetText } from "../shared";
import type { WidgetProps } from "../types";

const RANK = { info: 0, warning: 1, critical: 2 } as const;
const TONE = { info: "text-gray-800", warning: "text-amber-900", critical: "text-red-800" } as const;

/** alarm_list: active alarms in the widget's scope, newest first. */
export function AlarmList({ widget, input, now }: WidgetProps) {
  const fmt = useWidgetText();
  const cfg = widget.config ?? {};
  const floor =
    typeof cfg.min_severity === "string" && cfg.min_severity in RANK ? RANK[cfg.min_severity as keyof typeof RANK] : 0;
  const alarms = (input.alarms ?? [])
    .filter((a) => (cfg.include_acknowledged === true || !a.acknowledged) && RANK[a.severity] >= floor)
    .sort((a, b) => b.raised_at.localeCompare(a.raised_at));
  return (
    <Frame widget={widget} state={alarms.length ? "normal" : "empty"} title={widget.title}>
      {alarms.length === 0 ? (
        <p className="text-gray-700">{fmt.t("alarms.none")}</p>
      ) : (
        <ul className="min-h-0 flex-1 divide-y divide-gray-100 overflow-auto">
          {alarms.map((a) => (
            <li key={a.id} className="py-1.5">
              <div className="flex items-baseline gap-2">
                <span className={`text-xs font-medium ${TONE[a.severity]}`}>{fmt.t(`severity.${a.severity}`)}</span>
                <span className="flex-1 truncate text-gray-900">{a.name}</span>
                <span className="text-xs text-gray-700">{fmt.age(a.raised_at, now)}</span>
              </div>
              <span className="text-xs text-gray-700">{input.devices?.[a.device]?.name ?? ""}</span>
            </li>
          ))}
        </ul>
      )}
    </Frame>
  );
}
